/* PPA fulfillment: scoped to each current variant/form. No guessed warehouse,
   no stock mutations, and manufacturing origin/USMCA values remain server-owned. */
(function () {
  'use strict';
  if (window._ppa_warehouse_label_loaded) return;
  window._ppa_warehouse_label_loaded = true;
  let countryOverride = '';
  const upper = value => String(value || '').toUpperCase();
  const quantity = value => Math.max(0, Number(value) || 0);
  const roots = scope => {
    const root = scope?.querySelectorAll ? scope : document;
    const rows = Array.from(root.querySelectorAll('[data-ppa-fulfillment]'));
    if (root.matches?.('[data-ppa-fulfillment]')) rows.unshift(root);
    return rows;
  };
  function decideWarehouse(row, country) {
    if (row.dataset.stocked !== 'true') return '';
    const usa = quantity(row.dataset.usa), canada = quantity(row.dataset.canada);
    if (upper(country) === 'US') return usa > 0 ? 'USA' : canada > 0 ? 'Canada' : '';
    return canada > 0 ? 'Canada' : usa > 0 ? 'USA' : '';
  }
  function update(scope) {
    roots(scope).forEach(row => {
      const country = countryOverride || row.dataset.country;
      const shipFrom = decideWarehouse(row, country);
      const input = row.querySelector('input[name="properties[ship_from]"]');
      if (input) input.value = shipFrom;
      const productRoot = row.closest('product-info') || row.closest('product-form');
      productRoot?.querySelectorAll('[data-ppa-warehouse-label]').forEach(label => {
        label.textContent = shipFrom ? `Ships from ${shipFrom} warehouse` : '';
        label.dataset.shipFrom = shipFrom;
        label.hidden = !shipFrom;
      });
    });
    const mainProduct = document.querySelector('product-info[id^="MainProduct-"]');
    const needsTariff = !!mainProduct && roots(mainProduct).some(row =>
      upper(countryOverride || row.dataset.country) === 'US' && decideWarehouse(row, countryOverride || row.dataset.country) === 'Canada'
    );
    document.documentElement.classList.toggle('ppa-tariff-needed', needsTariff);
  }
  function get(scope) {
    const row = roots(scope)[0];
    if (!row) return { ship_from: '', origin_country: '', usmca_qualifies: 'false', country: countryOverride };
    const value = name => row.querySelector(`input[name="properties[${name}]"]`)?.value || '';
    return { ship_from: value('ship_from'), origin_country: value('origin_country'), usmca_qualifies: value('usmca_qualifies'), country: countryOverride || row.dataset.country };
  }
  window.PPA_WAREHOUSE_LABEL = {
    update,
    setCountry(iso) { countryOverride = upper(iso); update(document); },
    get
  };
  document.addEventListener('product-info:loaded', event => update(event.target));
  document.addEventListener('shopify:section:load', event => update(event.target));
  // Capture before Dawn serializes a cart form. Only recompute warehouse, never trade fields.
  document.addEventListener('submit', event => {
    if (event.target.matches?.('form[action*="/cart/add"]')) update(event.target);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update(document), { once: true });
  else update(document);
})();
